import { useState } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  employeeName: string;
}

const LEAVE_TYPES = ['Yıllık İzin', 'Hastalık İzni', 'Ücretsiz İzin', 'Doğum İzni', 'Babalık İzni', 'Evlilik İzni', 'Ölüm İzni', 'Diğer'];

export default function EmployeeLeaveModal({ isOpen, onClose, onSave, employeeName }: Props) {
  const [form, setForm] = useState({
    leave_type: 'Yıllık İzin',
    start_date: '',
    end_date: '',
    total_days: 1,
    status: 'Onaylandı',
    description: '',
  });

  if (!isOpen) return null;

  const calcDays = (start: string, end: string) => {
    if (!start || !end) return 0;
    const s = new Date(start);
    const e = new Date(end);
    if (e < s) return 0;
    return Math.ceil((e.getTime() - s.getTime()) / (1000 * 60 * 60 * 24)) + 1;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.start_date || !form.end_date || form.total_days <= 0) return;
    onSave({ ...form });
    setForm({ leave_type: 'Yıllık İzin', start_date: '', end_date: '', total_days: 1, status: 'Onaylandı', description: '' });
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-background-50 rounded-2xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-200/70">
          <h3 className="text-lg font-semibold text-foreground-900">İzin Kaydı</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer">
            <i className="ri-close-line text-lg text-foreground-500"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <p className="text-sm text-foreground-500">Personel: <span className="font-medium text-foreground-800">{employeeName}</span></p>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">İzin Türü</label>
            <select value={form.leave_type} onChange={e => setForm(prev => ({ ...prev, leave_type: e.target.value }))} className="input-base w-full">
              {LEAVE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-foreground-600 mb-1.5">Başlangıç <span className="text-red-400">*</span></label>
              <input type="date" value={form.start_date} onChange={e => {
                const start = e.target.value;
                const days = calcDays(start, form.end_date);
                setForm(prev => ({ ...prev, start_date: start, total_days: days }));
              }} className="input-base w-full" required />
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-600 mb-1.5">Bitiş <span className="text-red-400">*</span></label>
              <input type="date" value={form.end_date} onChange={e => {
                const end = e.target.value;
                const days = calcDays(form.start_date, end);
                setForm(prev => ({ ...prev, end_date: end, total_days: days }));
              }} className="input-base w-full" required />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Toplam Gün</label>
            <input type="number" value={form.total_days} readOnly className="input-base w-full bg-background-100" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Açıklama</label>
            <textarea value={form.description} onChange={e => setForm(prev => ({ ...prev, description: e.target.value }))} className="input-base w-full min-h-[70px]" placeholder="İzin açıklaması..." rows={2}></textarea>
          </div>
        </form>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-background-200/70">
          <button type="button" onClick={onClose} className="btn-secondary cursor-pointer whitespace-nowrap">İptal</button>
          <button type="button" onClick={handleSubmit} className="btn-primary cursor-pointer whitespace-nowrap">Kaydet</button>
        </div>
      </div>
    </div>
  );
}